/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBarAxis: {
  name: 'bar-axis';
  data: string;
} = {
  name: 'bar-axis',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 4a1 1 0 0 0-2 0v15a2 2 0 0 0 2 2h15a1 1 0 1 0 0-2V8a1 1 0 1 0-2 0v11h-3V6a1 1 0 1 0-2 0v13h-3v-9a1 1 0 0 0-2 0v9H5V4Z" fill="currentColor"/></svg>`,
};
